<template>
	<div class="modal fade" id="editCollaborator" data-backdrop="false" tabindex="-1" role="dialog"
		 aria-labelledby="editCollaborator" aria-hidden="true">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title d-inline">Update Collaborator</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<form @submit.prevent="update">
					<div class="modal-body">
						<div class="form-group row">
							<label class="col-sm-3 col-form-label">First Name</label>
							<div class="col-sm-9">
								<input type="text" v-validate="'required'"
									:class="{'form-control': true, 'is-invalid': formErrors.has('First Name') }"
									v-model="firstName" name="First Name">
								<div v-if="formErrors.has('First Name')" class="invalid-feedback">
									{{formErrors.first('First Name')}}
								</div>
							</div>
						</div>
						<div class="form-group row">
							<label class="col-sm-3 col-form-label">Last Name</label>
							<div class="col-sm-9">
								<input type="text" v-validate="'required'"
									:class="{'form-control': true, 'is-invalid': formErrors.has('Last Name') }"
									v-model="lastName" name="Last Name">
								<div v-if="formErrors.has('Last Name')" class="invalid-feedback">
									{{formErrors.first('Last Name')}}
								</div>
							</div>
						</div>
						<div class="form-group row">
							<label class="col-sm-3 col-form-label">Email</label>
							<div class="col-sm-9">
								<input type="email" v-validate="'required|email'"
									:class="{'form-control': true, 'is-invalid': formErrors.has('Email') }"
									v-model="email" name="Email">
								<div v-if="formErrors.has('Email')" class="invalid-feedback">
									{{formErrors.first('Email')}}
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
						<button type="submit" class="btn btn-primary">
							<div class="loader small_loader" v-if="action === 'update'"></div>
							<span v-else>Save</span>
						</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>


<script>
	import {db, functions} from "@/firebase/init";
	import swal from "sweetalert2";

	export default {
		name: "CollaboratorCreateModal",
		props: ["collaborator"],
		data: function () {
			return {
				firstName: '',
				lastName: '',
				email: '',
				userType: '',
				action: null,
			}
		},
		watch: {
			collaborator (value) {
                this.firstName = value.firstName;
				this.lastName = value.lastName;
				this.email = value.email;
				this.userType = value.userType;
			},
		},
		methods: {
			update() {
				this.$validator.validateAll().then((result) => {
					if (result) {
						this.action = 'update';
						db.collection("users")
							.doc(this.collaborator.docID).update({
							firstName: this.firstName,
							lastName: this.lastName,
							email: this.email
						})
							.then(() => {
								swal({
									title: "Update collaborator",
									text: "Collaborator successfully updated",
									type: "success",
									confirmButtonText: "OK",
									confirmButtonColor: "#6ACF98"
								});
								/* eslint-disable */
								$('#editCollaborator').modal('hide');
								/* eslint-disable */
								this.$emit('update-list');
							})
							.catch((error) => {
								/*
								this.addLog({
									message: "Error: Error add New Plan to DB. Message:" + error.message,
									level: "danger"
								});
								*/
								// Show error message to the user that the new plan has been added with pending status
								swal({
									title: "Something went wrong!",
									text: error.message,
									type: "error",
									confirmButtonText: "Try Again!",
									confirmButtonColor: "#EE8057"
								});
							})
							.finally(() => {
								this.action = null;
							});

						return false;
					}
				});
			}
		}
	};
</script>